import { Card } from "@/components/ui/card";
import { CheckSquare } from "lucide-react";

export const TasksListEmpty = () => {
  return (
    <Card className="p-6 text-center">
      <CheckSquare className="w-12 h-12 text-muted-foreground mx-auto mb-3" />
      <h3 className="font-medium text-lg mb-2">No tasks yet</h3>
      <p className="text-muted-foreground text-sm">
        Create your first task to get started with tracking your activities.
      </p>
    </Card>
  );
};
